import { render, staticRenderFns } from "./CreateLocation.vue?vue&type=template&id=3b5ab876&lang=pug"
import script from "./CreateLocation.vue?vue&type=script&lang=js"
export * from "./CreateLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports